import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../../containers/app/layout";
import { EmployerDashboard } from "./employer/index";
import { AdminDashboard } from "./admin";
import { EmployeeDashboard } from "./employee";
import { Fragment } from "react";

export const Dashboard = () => {
  const cookie = new Cookies();
  const { ROLE } = cookie.getAll() ?? {};

  const navigate = useNavigate();

  const handleAddEmployeeButtonClick = (e) => {
    e.preventDefault();
    navigate("/addnewemployee");
  };

  return (
    <Layout
      id={"dashboard"}
      title={"Dashboard"}
      location={ROLE === "employer" ? "dashboard" : null}
      handleCallToActionClick={handleAddEmployeeButtonClick}
    >
      {ROLE === "employer" && (
        <Fragment>
          <EmployerDashboard />
        </Fragment>
      )}
      {ROLE === "admin" && <AdminDashboard />}
      {ROLE === "employee" && <EmployeeDashboard />}
    </Layout>
  );
};
